import { useSelector } from "react-redux";
import Nav from "./UIResuableComponents/Nav/Nav";
import LoadingIcon from "./UIResuableComponents/LoadingIcon";
import { Success, Error } from "./UIResuableComponents/Error/ErrorSuccess";
const Main = (props) => {
  const isLoading = useSelector((state) => state.applevel.isLoading);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);
  const error = useSelector((state) => state.applevel);

  return (
    <div className="flex">
      {isLoading && <LoadingIcon />}
      {isSuccess && <Success msg={"Successfully Submitted"} />}
      {error.isAppLevelError && <Error msg={error.errMsg} />}
      {props.userAuth && <Nav />}
      <main className="relative w-[100%]  pl-[4.5rem]  md:pl-[20rem]">
        {props.children}
      </main>
    </div>
  );
};
export default Main;
